import { useState, useEffect } from 'react';

export const useOrientation = () => {
    const [isPortrait, setIsPortrait] = useState(true);

    // check Orientation
    const checkOrientation = () => {
        if (window.innerHeight > window.innerWidth) {
            setIsPortrait(true);
        } else {
            setIsPortrait(false);
        }
    };

    useEffect(() => {
        checkOrientation();
        window.addEventListener("resize", checkOrientation);
        return () => {
            window.removeEventListener("resize", checkOrientation);
        };
    }, []);

    return { isPortrait };
};
